import src from "./royale-lineup.webp"
export default { src, width: 1280, height: 1126 }
